import {useMutation} from '@tanstack/react-query';
import {UseFormReturn} from 'react-hook-form';
import {toast} from '@ui/toast/toast';
import {BackendResponse} from '@common/http/backend-response/backend-response';
import {onFormQueryError} from '@common/errors/on-form-query-error';
import {message} from '@ui/i18n/message';
import {apiClient} from '@common/http/query-client';

interface Response extends BackendResponse {}

interface Payload {
  phone?: string;
  cpf?: string;
  address_json?: string;
}

export function useUpdateContactInfo(form: UseFormReturn<Payload>) {
  return useMutation({
    mutationFn: (props: Payload) => updateContactInfo(props),
    onSuccess: () => {
      toast(message('Contact information updated'));
    },
    onError: r => onFormQueryError(r, form),
  });
}

function updateContactInfo(payload: Payload): Promise<Response> {
  return apiClient.put('users/me/contact-info', payload).then(r => r.data);
}
